import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GradeOrgModal from "./DashboardModalWidget/GradeOrgModal";

export function OrganizationGradeWidget({ org_grade, loading }) {
  const [showActiveModal, setShowActiveModal] = useState(false);
  const [typeGrade, setTypeGrade] = useState('');
  return (
    <>
      <GradeOrgModal
        typeGrade={typeGrade}
        closeModal={() => setShowActiveModal(false)}
        show={showActiveModal}
      />
      <div className="mt-0 row">
        <div className="col-lg-3 col-md-6 col-sm-12">
            <Card style={{height: '150px'}}>
              <CardBody>
                <div
                  className="
                d-flex
                justify-content-between 
                align-items-center
              "
                >
                  <h4 className="h4">Platinum</h4>
                  <OverlayTrigger
                    overlay={
                      <Tooltip id="products-edit-tooltip">Lihat Detail</Tooltip>
                    }
                  >
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
                      onClick={() => {
                        setTypeGrade('PLATINUM');
                        setShowActiveModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary">
                        <VisibilityIcon />
                      </span>
                    </a>
                  </OverlayTrigger>
                </div>

                <div className="d-flex justify-content-end">
                  <div className="h1 m-5">{+org_grade.totalGradePlat || 0}</div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <Card style={{height: '150px'}}>
              <CardBody>
                <div
                  className="
                d-flex
                justify-content-between 
                align-items-center
              "
                >
                  <h4 className="h4">Gold</h4>
                  <OverlayTrigger
                    overlay={
                      <Tooltip id="products-edit-tooltip">Lihat Detail</Tooltip>
                    }
                  >
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
                      onClick={() => {
                        setTypeGrade('GOLD');
                        setShowActiveModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary">
                        <VisibilityIcon />
                      </span>
                    </a>
                  </OverlayTrigger>
                </div>

                <div className="d-flex justify-content-end">
                  <div className="h1 m-5">{+org_grade.totalGradeGold || 0}</div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <Card style={{height: '150px'}} >
              <CardBody>
                <div
                  className="
                d-flex
                justify-content-between 
                align-items-center
              "
                >
                  <h4 className="h4">Silver</h4>
                  <OverlayTrigger
                    overlay={
                      <Tooltip id="products-edit-tooltip">Lihat Detail</Tooltip>
                    }
                  >
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
                      onClick={() => {
                        setTypeGrade('SILVER');
                        setShowActiveModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary">
                        <VisibilityIcon />
                      </span>
                    </a>
                  </OverlayTrigger>
                </div>

                <div className="d-flex justify-content-end">
                  <div className="h1 m-5">
                    {+org_grade.totalGradeSilver || 0}
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <Card style={{height: '150px'}}>
              <CardBody>
                <div
                  className="
                d-flex
                justify-content-between 
                align-items-center
              "
                >
                  <h4 className="h4">Bronze</h4>
                  <OverlayTrigger
                    overlay={
                      <Tooltip id="products-edit-tooltip">Lihat Detail</Tooltip>
                    }
                  >
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
                      onClick={() => {
                        setTypeGrade('BRONZE');
                        setShowActiveModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary">
                        <VisibilityIcon />
                      </span>
                    </a>
                  </OverlayTrigger>
                </div>

                <div className="d-flex justify-content-end">
                  <div className="h1 m-5">
                    {+org_grade.totalGradeBronze || 0}
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
    </>
  );
}
